import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type {
  ReportStatus,
  ShouttModerationState,
  ShouttStatus,
} from '@/types/moderation.types';

import {
  MODERATION_STATE_PILL,
  REPORT_STATUS_PILL,
  SHOUTT_STATUS_PILL,
} from '../constants';

type PillKind = 'shouttStatus' | 'moderationState' | 'reportStatus';

interface ModerationStatusPillProps {
  kind: PillKind;
  value: ShouttStatus | ShouttModerationState | ReportStatus;
  className?: string;
}

const ModerationStatusPill: FC<ModerationStatusPillProps> = ({ kind, value, className }) => {
  const meta =
    kind === 'shouttStatus'
      ? SHOUTT_STATUS_PILL[value as ShouttStatus]
      : kind === 'moderationState'
        ? MODERATION_STATE_PILL[value as ShouttModerationState]
        : REPORT_STATUS_PILL[value as ReportStatus];

  return (
    <Pill tone={meta.tone} className={className}>
      {meta.label}
    </Pill>
  );
};

export default ModerationStatusPill;
